import { useCallback, useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Stack, Typography, Box, FormControl, Modal } from "@mui/material";
import { MenuCompanies } from "../../modules/company/components/MenuCompanies";
import { ShevronIcon } from "../MuiIcons";
import { CompanyCard, ManageBtn, TitleCompany, Logo } from "./styles";
import {
  AUTH_COMPANY_ID,
  AUTH_COMPANY_NAME,
} from "../../modules/company/models";
import { useCompaniesList } from "../../modules/company/hooks/useCompaniesList";
import { useAuth } from "../../auth/useAuth";
import { useCompanyAuth } from "../../modules/company/hooks/useCompanyAuth";
import { getUserCompanyRole } from "../../modules/verificationRequest/network";

export const AppCompanyMenu = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const {
    setCompanyRole,
    setCompanyRoleObj,
    setIsSuperAdmin,
    setAuthorizedUserEmail,
  } = useAuth();
  const [data, loading, error, request] = useCompaniesList(true);
  const { companies } = useAuth();
  const [, , , , , authHandler] = useCompanyAuth();
  const [currentCompany, setCurrentCompany] = useState(
    localStorage.getItem(AUTH_COMPANY_NAME)
  );
  const authorizedCompanyId = localStorage.getItem(AUTH_COMPANY_ID) as string;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const getUserRole = async () => {
      const { companyRole, companyRoleObj, isSuperAdmin, email } =
        await getUserCompanyRole(authorizedCompanyId);
      setAuthorizedUserEmail(email);
      setCompanyRole(companyRole);
      setCompanyRoleObj(companyRoleObj);
      if (isSuperAdmin !== undefined) {
        setIsSuperAdmin(isSuperAdmin);
      }
    };
    getUserRole();
  }, [
    authorizedCompanyId,
    setCompanyRole,
    setIsSuperAdmin,
    setAuthorizedUserEmail,
    setCompanyRoleObj,
  ]);

  const filterData = useMemo(
    () => companies?.items.filter((e: any) => e.isActive),
    [companies]
  );

  const { logoCompany } = useMemo(
    () => ({
      logoCompany:
        currentCompany &&
        currentCompany
          .split(" ")
          .map((el: string) => el !== "-" && el[0].toUpperCase())
          .join(""),
    }),
    [currentCompany]
  );
  useEffect(() => {
    const authCompany = companies?.items?.find(
      (company: any) => company.id === authorizedCompanyId
    );
    if (authCompany && authCompany.name !== currentCompany) {
      authHandler(authCompany, authCompany.id);
      setCurrentCompany(localStorage.getItem(AUTH_COMPANY_NAME));
    }
  }, [companies, currentCompany, authorizedCompanyId, authHandler]);

  const handleOpen = useCallback(() => {
    request();
    setOpen(true);
  }, [request]);

  const handleClose = useCallback(() => setOpen(false), []);

  const handleManageBtn = () => {
    navigate("/companies?list");
    handleClose();
  };

  if (authorizedCompanyId === null) {
    return null;
  }

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      sx={{ width: "100%" }}
    >
      <Stack direction='row' alignItems='center' sx={{ width: "100%" }}>
        {logoCompany && (
          <Logo>
            <Typography variant='body1' color='#1C1F21' fontWeight='700'>
              {logoCompany}
            </Typography>
          </Logo>
        )}
        <Box>
          <>
            <FormControl
              variant='standard'
              sx={{ m: 1, minWidth: 120, position: "relative" }}
            >
              {currentCompany && (
                <TitleCompany
                  endIcon={<ShevronIcon />}
                  sx={{
                    "& .MuiButton-endIcon": {
                      marginRight: "4px",
                      position: "relative",
                      top: "4px",
                    },
                  }}
                  onClick={handleOpen}
                >
                  {currentCompany}
                </TitleCompany>
              )}
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
                sx={{
                  "& .MuiBackdrop-root": {
                    background: "none",
                  },
                }}
              >
                <CompanyCard>
                  {companies && (
                    <MenuCompanies
                      handleClose={handleClose}
                      data={{ items: filterData }}
                      isLoading={loading}
                      action={
                        (pathname !== "/companies" || search !== "?list") && (
                          <ManageBtn onClick={handleManageBtn}>
                            Manage companies
                          </ManageBtn>
                        )
                      }
                    />
                  )}
                </CompanyCard>
              </Modal>
            </FormControl>
          </>
        </Box>
      </Stack>
    </Stack>
  );
};
